import { Switch, SwitchProps } from 'antd'
import clsx from 'clsx'
import React from 'react'

type Props = Omit<SwitchProps, 'className'>

export function TipsySwitch({ checked, onChange, ...props }: Props) {
  return (
    <Switch
      className={clsx('!min-h-[19px] !min-w-[36px]', {
        '!bg-[#FF8A00]': checked,
        '!bg-white/20': !checked,
      })}
      size="small"
      onChange={onChange}
      checked={checked}
      {...props}
    />
  )
}
